<template>
    <div>
      <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
        <a-form-item label="标题">
          <a-input
            v-model:value="formState.title"
            placeholder="请输入标题"
            allow-clear
          />
        </a-form-item>
        <a-form-item label="类型" style="min-width: 300px">
          <a-select
            v-model:value="formState.type"
            placeholder="请选择类型"
            allow-clear
          >
            <a-select-option
              v-for="item in Object.keys(Enum.noticeType.value)"
              :key="item"
              :value="item"
            >
              {{ Enum.noticeType.value[item] }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态" style="min-width: 300px">
          <a-select
            v-model:value="formState.status"
            placeholder="请选择状态"
            allow-clear
          >
            <a-select-option
              v-for="item in Object.keys(Enum.noticeStatus.value)"
              :key="item"
              :value="item"
            >
              {{ Enum.noticeStatus.value[item] }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button v-if="ableSearch" type="primary" @click="handelSearch">查询</a-button>
        </a-form-item>
        <a-form-item style="position: absolute; right: 50px">
          <a-button v-if="ableAdd" type="primary" @click="showAddModal">新增</a-button>
        </a-form-item>
      </a-form>
      <a-modal
        v-model:open="open"
        :title="isDetail ? '通知预览' : isEdit ? '修改通知' : '新增通知'"
        :footer="null"
        :destroyOnClose="true"
        :width="isDetail ? '700px' : '1200px'"
      >
        <add-notice
          :v-if="open"
          @submit="handelEditOk"
          :isEdit="isEdit"
          :isDetail="isDetail"
          :editData="editData"
          :treeData="treeData"
        ></add-notice>
      </a-modal>
      <a-table
        :columns="columns"
        :row-key="(record) => record.uuid"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record, index }">
          <template v-if="column.key === 'rowIndex'">
            {{ index + 1 }}
          </template>
          <template v-if="column.key === 'type'">
            {{ Enum.noticeType.value[record.type] }}
          </template>
          <template v-else-if="column.key === 'status'">
            <a-tag :color="['', 'green', 'orange'][record.status]">
              {{ Enum.noticeStatus.value[record.status] }}
            </a-tag>
          </template>
          <template v-else-if="column.key === 'departName'">
            {{ record.departList?.map(item => item.name)?.join(',') }}
          </template>
          <template v-else-if="column.key === 'action'">
            <span>
              <a-popconfirm
                title="确认启用？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="handleStatusChange(record.notice_id, 1)"
              >
                <a-button v-if="record.status == 0 || record.status == 2">
                  启用
                </a-button>
              </a-popconfirm>
              
              <a-popconfirm
                title="确认停用？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="handleStatusChange(record.notice_id, 2)"
              >
                <a-button v-if="record.status == 1">
                  停用
                </a-button>
              </a-popconfirm>
              <a-button @click="showDetailModal(record, true)">预览</a-button>
              <a-button @click="showDetailModal(record, false)" v-if="ableEdit && record.status != 1">编辑</a-button>
              <a-popconfirm
                title="确认删除？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="delRow(record)"
                v-if="ableEdit"
              >
                <a-button danger>删除</a-button>
              </a-popconfirm>
              <a-button @click="getFileSearch(record.notice_id)" v-if="record.status == 0 || record.status == 2">
                附件
              </a-button>
            </span>
          </template>
        </template>
      </a-table>
      <a-modal
        v-model:visible="fileModalVisible"
        title="附件列表"
        :footer="null"
        width="900px"
      >
        <a-button style="float: right;" type="primary" @click="handleFileUpload">上传</a-button>
        <a-table
          :columns="fileColumns"
          :data-source="fileList"
          :pagination="false"
          rowKey="id"
          size="small"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'file_url'">
              <a :href="record.file_url" target="_blank">{{ record.file_name }}</a>
            </template>
            <template v-if="column.key === 'action'">
              <a-popconfirm
                title="确认删除？"
                ok-text="确认"
                cancel-text="取消"
                @confirm="handleFileDel(record.id)"
              >
                <a-button danger>删除</a-button>
              </a-popconfirm>
            </template>
          </template>
        </a-table>
      </a-modal>

      <a-modal
        v-model:visible="fileVisible"
        title="附件上传"
        :footer="null"
        width="400px"
      >
        <div style="margin-bottom: 16px">
          <FileUpload
            fileField="file"
            :handelBeforeUpload="true"
            :number="5"
            @beforeUpload="beforeUpload"
          >
            <a-button type="primary" block>
              <upload-outlined />
              {{ file ? '重新上传(已上传)' : '选择文件' }}
            </a-button>
          </FileUpload>
        </div>
        
        <div v-if="files" style="margin-bottom: 16px">
          <a-list item-layout="horizontal" :data-source="[files]">
            <template #renderItem="{ item }">
              <a-list-item>
                <a-list-item-meta :description="`${(item.size / 1024).toFixed(2)} KB`">
                  <template #title>
                    {{ item.name }}
                  </template>
                  <template #avatar>
                    <file-outlined style="font-size: 24px" />
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </template>
          </a-list>
        </div>
        
        <a-progress
          v-if="uploadProgress > 0"
          :percent="uploadProgress"
          status="active"
          style="margin-bottom: 16px"
        />
        
        <div style="text-align: right">
          <a-button @click="fileVisible = false" style="margin-right: 8px">取消</a-button>
          <a-button type="primary" @click="confirmUpload" :loading="uploading">
            {{ uploading ? '上传中...' : '确定上传' }}
          </a-button>
        </div>
      </a-modal>
    </div>
  </template>
  <script setup>
    import { ref, reactive, onMounted, toRefs, computed } from 'vue'
    import { getList, delNotice, getDetail, updateStatus, uploadSearch, uploadNotice, uploadDel } from '@/api/notice/notice'
    import { getDept } from '@/api/system_manage/dept'
    import { buildTree } from '@/utils/tree'
    import AddNotice from './action/addNotice.vue'
    import { message } from 'ant-design-vue'
    import FileUpload from '@/components/form/file_upload'
    import { useStore } from 'vuex'
    const store = useStore()
    const Enum = toRefs(store.state.common)

    const permissionList = computed(() => store.getters['user/permissionList'])
    const ableSearch = computed(() =>
      !!permissionList.value?.find(item => item.code === 'notice:list')
    )
    const ableAdd = computed(() =>
      !!permissionList.value?.find(item => item.code === 'notice:add')
    )
    const ableEdit = computed(() =>
      !!permissionList.value?.find(item => item.code === 'notice:edit')
    )
  
    //1、检索
    const formState = reactive({
      title: '',
      type: undefined,
      status: undefined,
    })
    function handelSearch() {
      pagination.value.current = 1
      fetch()
    }
  
    // 附件表格列定义
    const fileColumns = [
      {
        title: '文件名',
        dataIndex: 'file_name',
        key: 'file_name',
        align: 'left',
      },
      {
        title: '文件类型',
        dataIndex: 'file_type',
        key: 'file_type',
        align: 'left',
      },
      {
        title: '文件大小',
        dataIndex: 'file_size',
        key: 'file_size',
        align: 'left',
      },
      {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        align: 'left',
      },
      {
        title: '文件',
        key: 'file_url',
        align: 'left',
      },
      {
        title: '操作',
        key: 'action',
        align: 'left',
      },
    ]
    
    //2、表格
    const columns = [
      {
        title: '序号',
        dataIndex: 'rowIndex',
        key: 'rowIndex',
        align: 'center',
        width: 50,
        fixed: 'left',
      },
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        align: 'left',
      },
      {
        title: '目标部门',
        dataIndex: 'departName',
        key: 'departName',
        align: 'left',
      },
      {
        title: '类型',
        dataIndex: 'type',
        key: 'type',
        align: 'left',
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        align: 'left',
      },
      {
        title: '发布时间',
        dataIndex: 'publish_time',
        key: 'publish_time',
        align: 'left',
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        align: 'left',
      },
    ]
    const dept = ref([])
    const tableData = ref([])
    const treeData = ref([])
    const pagination = ref({
      current: 1,
      pageSize: 10,
      showLessItems: true,
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: (total, range) => {
      return `共 ${total} 条`
    },
    })
    const loading = ref(false)
    function handleTableChange(page) {
      pagination.value = { ...pagination.value, ...page }
      fetch()
    }
    function fetch() {
      loading.value = true
      getList({
        size: pagination.value.pageSize,
        pn: pagination.value.current,
        ...formState,
      }).then(({ data }) => {
        pagination.value.total = data.total
        loading.value = false
        tableData.value = data.list?.map(item => {
          return {
            ...item,
            status: item.status.toString(),
          }
        })
      })
      getDept().then(({ data }) => {
        const tree = buildTree(data, { idName: 'depart_id' })
        dept.value = data
        treeData.value = tree
      })
    }
    onMounted(fetch)

    const fileVisible = ref(false)
    const handleFileUpload = () => {
      files.value = null
      fileVisible.value = true
    }
    const confirmUpload = () => {
      const formData = new FormData()
      formData.append('file', files.value)
      formData.append('noticeId', currentId.value)
      uploadNotice(formData).then((res) => {
        if (res.code === 1000) {
          message.success('上传成功')
          fileVisible.value = false
          getFileSearch(currentId.value)
        } else {
          message.warn('上传失败')
        }
      })
    }

    const fileList = ref([])
    const files = ref(null)
    const currentId = ref(null)
    const fileModalVisible = ref(false)
    function beforeUpload(file) {
      // 将选中的文件保存到file引用中
      files.value = file;
      return false; // 返回false阻止默认上传行为
    }
    const getFileSearch = (id) => {
      currentId.value = id
      uploadSearch({ noticeId: id }).then((res) => {
        if (res.code === 1000) {
          fileList.value = res.data;
          fileModalVisible.value = true
        } else {
          message.warn('获取附件失败')
        }
      })
    }

    const handleFileDel = (id) => {
      uploadDel({ id: id }).then((res) => {
        if (res.code === 1000) {
          message.success('删除成功')
          getFileSearch(currentId.value)
        } else {
          message.warn('删除失败')
        }
      })
    }

    const handleStatusChange = (id, status) => {
      updateStatus({ noticeId: id, status: status }).then((res) => {
        if (res.code === 1000) {
          message.success('修改状态成功')
          fetch()
        } else {
          message.warn('修改状态失败')
        }
      })
    }
  
    //3、添加、编辑
    const open = ref(false)
    const isEdit = ref(false)
    const editData = ref(null)
    const showAddModal = () => {
      editData.value = null
      isEdit.value = false
      isDetail.value = false
      open.value = true
    }
    const editOk = () => {
      open.value = false
    }
    function clearEditData() {
      editData.value = null
    }
    function handelEditOk() {
      fetch()
      editOk()
      clearEditData()
    }
  
    //5、删除
    async function delRow(data) {
      const res = await delNotice({ noticeId: data.notice_id })
      if (res.success) {
        message.success('删除成功！')
        fetch()
      } else {
        message.warn('删除失败' + res.message)
      }
    }
    
    //6、详情
    const isDetail = ref(false)
    async function showDetailModal(data, detailBool) {
      const res = await getDetail({ noticeId: data.notice_id })
      if (res.data) {
        editData.value = res.data
        isEdit.value = true
        isDetail.value = detailBool
        open.value = true
      } else {
        message.warn('获取预览失败' + res.message)
      }
    }
  </script>
  